import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class NavigationService {
  private router = inject(Router);

  toDeviceConfiguration(device: string, floorplanId: string, existingConfigId?: string) {
    const url = this.router.url;
    this.router.navigate([url.slice(0, url.indexOf("floorplans")) + device], {
      queryParams: {
        floorplan_id: floorplanId,
        config_id: existingConfigId,
      },
    });
  }

  toGroupConfiguration(floorplanId: string, groupId: string, url: string) {
    this.router.navigate([url.slice(0, url.indexOf("floorplans")) + "group"], {
      queryParams: {
        floorplan_id: floorplanId,
        group_id: groupId,
      },
    });
  }
}
